import { useState, useEffect } from "react"
import { Dropdown } from "react-bootstrap"
import LitigationBatchHeader from "../../Components/Litigation/LitigationBatchHeader"
import InputLabel from "@material-ui/core/InputLabel"
import Arrow from "../../../Static/RawImages/arrow.png"
import { Link } from "react-router-dom"
import { batchListingAPI, generateSample, approveSample, sendSample } from "../../../API/litigationApis"
import { showToast } from "../../../utils/handleToast"
import Pagination from "../../Components/pagination/Pagination"
import { Modal, Button, Form } from "react-bootstrap"
import SelectDropdown from "../../../ui/forms/SelectDropdown";

export default function LitigationBatch() {
  // State for batches data
  const [batches, setBatches] = useState([])
  const [loading, setLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenClient, setIsModalOpenClient] = useState(false);
  const [isModalOpenForApprove, setIsModalOpenForApprove] = useState(false);
  const [selectedValue, setSelectedValue] = useState('');
  const [pendingBatch, setPendingBatch] = useState(null); // Store the batch awaiting action

  // Category options for dropdowns
  const categoryOptions = [
    { label: "--Choose--", value: "" },
    { label: "Summary Suit", value: "summary_suit" },
    { label: "Commercial Suit", value: "comm_suit" },
    { label: "Pre Execution Petition", value: "pre_ep" },
    { label: "Mediation Application", value: "mediation_application" },
    { label: "Interim Application", value: "interim_application" },
    { label: "Original Application", value: "original_application" },
    { label: "Loan Recall Notice", value: "loan_recall_notice" },
    { label: "Sec 95", value: "sec_95"}
  ];

  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    page_number: 1
  })

  // offcanvas & modal state
  const [showHistory, setShowHistory] = useState(false)
  const [showUpload, setShowUpload] = useState(false)

  // State for reload functionality
  const [hitReload, setHitReload] = useState(false)

  // State for search parameters (used by the header)
  const [searchParameter, setSearchParameter] = useState({})

  // State for selected batches
  const [selectedBatches, setSelectedBatches] = useState([])

  // State for download loading per batch
  const [downloadingBatches, setDownloadingBatches] = useState({})

  // State for generate sample loading per batch
  const [generatingSample, setGeneratingSample] = useState({})

  // State for approve sample loading per batch
  const [approvingSample, setApprovingSample] = useState({})

  const [sendingSample, setsendingSample] = useState({})

  // Generate Sample functionality 
  const handleGenerateSample = async (batch, dropdownValue) => {
    try {
      setGeneratingSample(prev => ({
        ...prev,
        [batch.id]: true
      }))

      // Create FormData for the API call
      const formData = new FormData()
      formData.append('batch_id', batch.id.toString())
      formData.append('category', dropdownValue)

      const response = await generateSample(formData)

      if (response?.status && response?.data) {
        // Use the download media API URL format
        const downloadUrl = `https://api.themedius.ai/dashboard/api/download_media/?url=${encodeURIComponent(response.data)}`

        // Create a temporary anchor element to trigger download
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = `Sample_Batch_${batch.batchNo}.pdf` // Suggested filename
        link.target = '_blank' // Open in new tab as fallback

        // Append to body, click, and remove
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        showToast({
          variant: "success",
          message: `Sample generated and downloaded successfully for Batch ${batch.batchNo}`
        })
      } else {
        throw new Error(response?.message || "Failed to generate sample")
      }

    } catch (error) {
      console.error("Error generating sample:", error)
      showToast({
        variant: "error",
        message: error.message || "Failed to generate sample. Please try again."
      })
    } finally {
      setGeneratingSample(prev => {
        const updated = { ...prev }
        delete updated[batch.id]
        return updated
      })
    }
  }

  // Generate Sample functionality 
  const handleSendSampleToClient = async (batch, dropdownValue) => {
    try {
      setsendingSample(prev => ({
        ...prev,
        [batch.id]: true
      }))

      // Create FormData for the API call
      const formData = new FormData()
      formData.append('batch_id', batch.id.toString())
      formData.append('category', dropdownValue)

      const response = await sendSample(formData)

      if (response?.status && response?.data) {
        // Use the download media API URL format
        const downloadUrl = `https://api.themedius.ai/dashboard/api/download_media/?url=${encodeURIComponent(response.data)}`

        // Create a temporary anchor element to trigger download
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = `Sample_Batch_${batch.batchNo}.pdf` // Suggested filename
        link.target = '_blank' // Open in new tab as fallback

        // Append to body, click, and remove
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        showToast({
          variant: "success",
          message: `Sample generated and downloaded successfully for Batch ${batch.batchNo}`
        })
      } else {
        throw new Error(response?.message || "Failed to generate sample")
      }

    } catch (error) {
      console.error("Error generating sample:", error)
      showToast({
        variant: "error",
        message: error.message || "Failed to generate sample. Please try again."
      })
    } finally {
      setsendingSample(prev => {
        const updated = { ...prev }
        delete updated[batch.id]
        return updated
      })
    }
  }

  // Approve Sample functionality
  const handleApproveSample = async (batch, dropdownValue) => {
    try {
      setApprovingSample(prev => ({
        ...prev,
        [batch.id]: true
      }))

      // Create form data for the API call
      const formData = new FormData()
      formData.append('batch_id', batch.id.toString())
      formData.append('category', dropdownValue)

      const response = await approveSample(formData)

      if (response?.status) {
        showToast({
          variant: "success",
          message: `Sample approved successfully for Batch ${batch.batchNo}`
        })
      } else {
        throw new Error(response?.message || "Failed to approve sample")
      }

    } catch (error) {
      console.error("Error approving sample:", error)
      showToast({
        variant: "error",
        message: error.message || "Failed to approve sample. Please try again."
      })
    } finally {
      setApprovingSample(prev => {
        const updated = { ...prev }
        delete updated[batch.id]
        return updated
      })
    }
  }

  // Download Report functionality
  const handleDownloadReport = async (batch) => {
    try {
      // Check if batch_file_loc exists
      if (!batch.originalData?.batch_file_loc) {
        showToast({
          variant: "warning",
          message: "Batch file not available for this batch"
        })
        return
      }

      // Set loading state for this specific batch
      setDownloadingBatches(prev => ({
        ...prev,
        [batch.id]: true
      }))

      // Construct the download URL using batch_file_loc
      const downloadUrl = `https://api.themedius.ai/dashboard/api/download_media/?url=${encodeURIComponent(batch.originalData.batch_file_loc)}`

      // Create a temporary anchor element to trigger download
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = `Batch_${batch.batchNo}_Report.pdf` // Suggested filename
      link.target = '_blank' // Open in new tab as fallback

      // Append to body, click, and remove
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      showToast({
        variant: "success",
        message: `Download started for Batch ${batch.batchNo}`
      })

    } catch (error) {
      console.error("Error downloading report:", error)
      showToast({
        variant: "error",
        message: "Failed to download report. Please try again."
      })
    } finally {
      // Remove loading state for this batch
      setDownloadingBatches(prev => {
        const updated = { ...prev }
        delete updated[batch.id]
        return updated
      })
    }
  }

  // Alternative download method using fetch (in case direct link doesn't work)
  const handleDownloadReportWithFetch = async (batch) => {
    try {
      if (!batch.originalData?.batch_file_loc) {
        showToast({
          variant: "warning",
          message: "Batch file not available for this batch"
        })
        return
      }

      setDownloadingBatches(prev => ({
        ...prev,
        [batch.id]: true
      }))

      const downloadUrl = `https://api.themedius.ai/dashboard/api/download_media/?url=${encodeURIComponent(batch.originalData.batch_file_loc)}`

      const response = await fetch(downloadUrl)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.download = `Batch_${batch.batchNo}_Report.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      // Clean up the blob URL
      window.URL.revokeObjectURL(url)

      showToast({
        variant: "success",
        message: `Report downloaded successfully for Batch ${batch.batchNo}`
      })

    } catch (error) {
      console.error("Error downloading report:", error)
      showToast({
        variant: "error",
        message: "Failed to download report. Please try again."
      })
    } finally {
      setDownloadingBatches(prev => {
        const updated = { ...prev }
        delete updated[batch.id]
        return updated
      })
    }
  }

  // Fetch batches from API
  const fetchBatches = async (page = 1, searchParams = {}) => {
    try {
      setLoading(true)

      // Prepare API parameters
      const params = {
        page: page,
        ...searchParams
      }

      const response = await batchListingAPI(params)

      if (response?.status && response?.data) {
        // Transform API data to match expected batch structure
        const transformedBatches = response.data.results?.map((item, index) => ({
          id: item.id,
          batchNo: item.batch_name || `BATCH-${item.id}`,
          date: formatDate(item.created_at) || formatDate(item.uploaded_date) || formatDate(item.assignment_date) || "N/A",
          totalCases: item.total_cases || 1,
          location: getLocationString(item),
          casesAssigned: item.total_cases || 1,
          isNew: isNewBatch(item.created_at),
          progress: {
            notFiled: getRandomProgress(), // Replace with actual data when available
            firstHearing: getRandomProgress(),
            inProgress: getRandomProgress(),
            closed: getRandomProgress(),
          },
          // Store original data for reference
          originalData: item
        })) || []

        setBatches(transformedBatches)
        setPagination({
          count: response.data.count || 0,
          next: response.data.next,
          previous: response.data.previous,
          page_number: response.data.page_number || page,
          total_pages: Math.ceil((response.data.count || 0) / 20)
        })
      } else {
        throw new Error(response?.message || "Failed to fetch batches")
      }
    } catch (error) {
      console.error("Error fetching batches:", error)
      showToast({
        variant: "error",
        message: error.message || "Failed to fetch batches"
      })
      setBatches([])
    } finally {
      setLoading(false)
    }
  }

  const totalPages = Math.ceil(pagination.count / 20)

  // Helper function to get location string from API data
  const getLocationString = (item) => {
    const parts = []

    if (item.branch_name) parts.push(item.branch_name)
    if (item.jurisdiction_state) parts.push(item.jurisdiction_state)
    if (item.product_group) parts.push(item.product_group)

    return parts.length > 0 ? parts.join(', ') : 'N/A'
  }

  // Helper function to generate random progress (replace with actual logic)
  const getRandomProgress = () => {
    return Math.floor(Math.random() * 101) // 0-100
  }

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return null
    try {
      return new Date(dateString).toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      })
    } catch {
      return null
    }
  }

  // Helper function to check if batch is new (created today)
  const isNewBatch = (createdAt) => {
    if (!createdAt) return false
    const createdDate = new Date(createdAt)
    const today = new Date()

    // Check if the batch was created today
    return createdDate.toDateString() === today.toDateString()
  }

  // Check if any action is loading for a specific batch
  const isAnyActionLoading = (batchId) => {
    return downloadingBatches[batchId] || generatingSample[batchId] || approvingSample[batchId]
  }

  // Initial load effect
  useEffect(() => {
    setTimeout(() => {
      fetchBatches(1, searchParameter)
    }, 500);
  }, [])

  // Reload effect
  useEffect(() => {
    if (hitReload) {
      setTimeout(() => {
        fetchBatches(pagination.page_number, searchParameter)
        setHitReload(false)
      }, 500);
    }
  }, [hitReload])

  // Search parameter change effect
  useEffect(() => {
    if (Object.keys(searchParameter).length > 0) {
      setTimeout(() => {
        fetchBatches(1, searchParameter)
      }, 500);
    }
  }, [searchParameter])

  // Toggle selection of a batch
  const toggleBatchSelection = (batchId) => {
    if (selectedBatches.includes(batchId)) {
      setSelectedBatches(selectedBatches.filter((id) => id !== batchId))
    } else {
      setSelectedBatches([...selectedBatches, batchId])
    }
  }

  // Toggle selection of all batches
  const toggleAllBatches = () => {
    if (selectedBatches.length === batches.length) {
      setSelectedBatches([])
    } else {
      setSelectedBatches(batches.map((batch) => batch.id))
    }
  }

  // Handle pagination
  const handlePageChange = (page) => {
    fetchBatches(page, searchParameter)
  }

  const sampleHistory = [
    { day: "10", month: "Nov 20", court: "District Judge: 1 Addl. Sess. Judge", hearingDate: "19 Jul 2021", status: "Awaiting Notice" },
    { day: "8", month: "Nov 20", court: "District Judge: 1 Addl. Sess. Judge", hearingDate: "13 Jul 2021", status: "Awaiting Notice" },
  ]

  return (
    <>
      <LitigationBatchHeader
        setSearchParameter={setSearchParameter}
        setHitReload={setHitReload}
      />
      <hr className="mt-3 mb-5" />

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2 text-muted">Loading batches...</p>
        </div>
      ) : batches.length === 0 ? (
        <div className="text-center py-5">
          <p className="text-muted">No batches found</p>
        </div>
      ) : (
        <>
          {/* Batches count and bulk actions */}
          <div className="row mb-3">
            <div className="col-md-6">
              <p className="text-muted">
                Showing {batches.length} of {pagination.count} batches
              </p>
            </div>
            <div className="col-md-6 text-end">
              {selectedBatches.length > 0 && (
                <span className="text-info">
                  {selectedBatches.length} batch(es) selected
                </span>
              )}
            </div>
          </div>

          {batches.map((batch, index) => (
            <div key={batch.id}>
              <div className="row d-flex justify-between batch-listing">
                {/* Left column - Batch info */}
                <div className="col-md-3">
                  <div className="d-flex align-start">
                    <div className="form-check me-3 mt-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={selectedBatches.includes(batch.id)}
                        onChange={() => toggleBatchSelection(batch.id)}
                      />
                    </div>
                    <div className="border-right-dotted w-100">
                      <p className="mb-2">
                        <Link to={`/admin/litigation/cases/${batch.id}`}>
                          <b className="text-blue">Batch No. {batch.id}</b>
                        </Link>
                      </p>
                      <p className="mb-2">
                        <span className="batch-name" title={batch.location}>
                          Ref - {batch.batchNo}
                        </span>
                      </p>
                      <p className="mb-2">
                        Upload Date - {batch.date}
                      </p>
                      <p className="mb-2">
                        Total Cases: {batch.totalCases.toLocaleString()}
                      </p>
                      {/* Additional info from API */}
                      {batch.originalData?.client_contact_no && (
                        <p className="mb-2">
                          Contact: {batch.originalData.client_contact_no}
                        </p>
                      )}
                      {batch.originalData?.client_email_id && (
                        <p className="mb-2">
                          Email: {batch.originalData.client_email_id}
                        </p>
                      )}
                      {batch.originalData?.litigation_client?.name && (
                        <p className="mb-2">
                          Client: {batch.originalData.litigation_client.name}
                        </p>
                      )}
                      {batch.originalData?.relief_sought && (
                        <p className="mb-2">
                          Relief: {batch.originalData.relief_sought}
                        </p>
                      )}
                      <div>
                        {batch.isNew ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width="43" height="25" viewBox="-263.6 383.2 43.3 25.2">
                            <path
                              className="st0"
                              fill="#FF5700"
                              d="M-220.3,395.8c0-7-5.7-12.6-12.6-12.6l-30.6,0l0,25.2l30.7,0C-226,408.4-220.3,402.8-220.3,395.8z M-232.9,406.6l-28.8,0l0-21.6l28.8,0c6,0,10.8,4.9,10.8,10.8C-222.1,401.8-227,406.6-232.9,406.6z"
                            />
                            <path
                              className="st0"
                              fill="#FF5700"
                              d="M-232.9,386.8l-27,0l0,18l27,0c5,0,9-4,9-9C-223.9,390.8-227.9,386.8-232.9,386.8z M-250.5,399.4l-1.6-2.8 c-0.4-0.8-0.9-1.7-1.3-2.6l0,0c0,1,0.1,2,0.1,3.2l0,2.2l-1.5,0l0-7.3l1.9,0l1.5,2.7c0.4,0.8,0.9,1.7,1.2,2.5l0,0 c-0.1-1-0.1-1.9-0.1-3l0-2.1l1.5,0l0,7.3L-250.5,399.4L-250.5,399.4z M-247.3,399.4l0-7.3l4.5,0l0,1.4l-2.8,0l0,1.5l2.7,0l0,1.3 l-2.7,0l0,1.7l3,0l0,1.3C-242.7,399.4-247.3,399.4-247.3,399.4z M-236.4,399.4l-0.6-3.1c-0.1-0.7-0.3-1.4-0.3-2.2l0,0 c-0.1,0.8-0.3,1.5-0.4,2.2l-0.7,3.1l-1.8,0l-1.7-7.3l1.8,0l0.6,3c0.2,0.9,0.3,1.8,0.4,2.5l0,0c0.1-0.8,0.3-1.7,0.5-2.6l0.6-3 l1.8,0l0.6,3.1c0.2,0.9,0.3,1.6,0.4,2.4l0,0c0.1-0.8,0.3-1.7,0.4-2.5l0.6-3l1.7,0l-1.9,7.3 C-234.6,399.4-236.4,399.4-236.4,399.4z M-228.2,397.7c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,2,0.9,2,2 C-226.2,396.9-227.1,397.8-228.2,397.7z"
                            />
                          </svg>
                        ) : (
                          <p>
                            Status - <span className="text-success fw-bold">
                              {batch.originalData?.batch_status || 'Active'}
                            </span>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Middle column - Progress visualization */}
                <div className="col-md-6 border-right-dotted">
                  <div className="row">
                    <div className="col-md-6">
                      {/* Circle progress indicator */}
                      <div className="ps-4">
                        <div
                          className="position-relative"
                          style={{ width: "120px", height: "120px", margin: "0 auto" }}
                        >
                          {/* Circle background */}
                          <div
                            className="position-absolute top-0 start-0 rounded-circle"
                            style={{
                              width: "100%",
                              height: "100%",
                              border: "3px solid #f0f0f0",
                            }}
                          ></div>

                          {/* Progress circle - only show if there are cases assigned */}
                          {batch.casesAssigned > 0 && (
                            <div
                              className="position-absolute top-0 start-0 rounded-circle"
                              style={{
                                width: "100%",
                                height: "100%",
                                border: "3px solid #20B2AA",
                                borderRadius: "50%",
                                clipPath: "polygon(50% 50%, 50% 0%, 100% 0%, 100% 100%, 0% 100%, 0% 0%, 50% 0%)",
                                transform: "rotate(45deg)",
                              }}
                            ></div>
                          )}

                          {/* Small circle indicator */}
                          {batch.casesAssigned > 0 && (
                            <div
                              className="position-absolute"
                              style={{
                                width: "12px",
                                height: "12px",
                                backgroundColor: "#20B2AA",
                                borderRadius: "50%",
                                top: "0%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                              }}
                            ></div>
                          )}

                          {/* Text in center */}
                          <div className="position-absolute top-50 start-50 translate-middle text-center">
                            <div className="fw-bold">{batch.casesAssigned.toLocaleString()}</div>
                            <div className="small text-muted">Cases Assigned</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      {/* Progress bars */}
                      <div className="row status-progress">
                        <div className="mb-3">
                          <div className="d-flex justify-content-between mb-1">
                            <span className="small">Not Filed</span>
                          </div>
                          <div className="progress" style={{ height: "6px" }}>
                            <div
                              className="progress-bar bg-info"
                              style={{ width: `${batch.progress.notFiled}%` }}
                            ></div>
                          </div>
                        </div>

                        <div className="mb-3">
                          <div className="d-flex justify-content-between mb-1">
                            <span className="small">First Hearing</span>
                          </div>
                          <div className="progress" style={{ height: "6px" }}>
                            <div
                              className="progress-bar bg-info"
                              style={{ width: `${batch.progress.firstHearing}%` }}
                            ></div>
                          </div>
                        </div>

                        <div className="mb-3">
                          <div className="d-flex justify-content-between mb-1">
                            <span className="small">In-progress</span>
                          </div>
                          <div className="progress" style={{ height: "6px" }}>
                            <div
                              className="progress-bar bg-info"
                              style={{ width: `${batch.progress.inProgress}%` }}
                            ></div>
                          </div>
                        </div>

                        <div>
                          <div className="d-flex justify-content-between mb-1">
                            <span className="small">Closed</span>
                          </div>
                          <div className="progress" style={{ height: "6px" }}>
                            <div className="progress-bar bg-info" style={{ width: `${batch.progress.closed}%` }}></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right column - Action dropdown */}
                <div className="col-md-3 ps-5">
                  <InputLabel id="label" className="mb-1">
                    Action
                  </InputLabel>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="primary"
                      id="dropdown-basic"
                      className="w-100 text-start select-style"
                      disabled={isAnyActionLoading(batch.id)}
                    >
                      {isAnyActionLoading(batch.id) ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Processing...
                        </>
                      ) : (
                        <>
                          Select <img src={Arrow} alt="Sort" />
                        </>
                      )}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="select-style-dropdown">
                      {/* Download Report Action */}
                      <Dropdown.Item
                        onClick={() => handleDownloadReport(batch)}
                        disabled={!batch.originalData?.batch_file_loc || isAnyActionLoading(batch.id)}
                      >
                        {!batch.originalData?.batch_file_loc ? (
                          <span className="text-muted">Download Report (Not Available)</span>
                        ) : downloadingBatches[batch.id] ? (
                          <span>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Downloading...
                          </span>
                        ) : (
                          "Download Report"
                        )}
                      </Dropdown.Item>

                      {/* Generate Sample Action */}
                      <Dropdown.Item
                        onClick={() => {
                          setPendingBatch(batch);
                          setIsModalOpen(true);
                        }}
                        disabled={isAnyActionLoading(batch.id)}
                      >
                        {generatingSample[batch.id] ? (
                          <span>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Generating Sample...
                          </span>
                        ) : ("Generate Sample")}
                      </Dropdown.Item>


                      {/* Approve Sample Action */}
                      <Dropdown.Item
                        onClick={() => {
                          setPendingBatch(batch);
                          setIsModalOpenForApprove(true);
                        }}
                        disabled={isAnyActionLoading(batch.id)}
                      >
                        {approvingSample[batch.id] ? (
                          <span>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Approving Sample...
                          </span>
                        ) : (
                          "Approve Sample"
                        )}
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          setPendingBatch(batch);
                          setIsModalOpenClient(true);
                        }}
                        disabled={isAnyActionLoading(batch.id)}
                      >
                        {sendingSample[batch.id] ? (
                          <span>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Sending Sample to Client
                          </span>
                        ) : (
                          "Send Sample to Client"
                        )}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <hr className="mt-4 mb-4" />
            </div>
          ))}


          {/* Pagination */}
          <div className="d-flex justify-content-end">
            <Pagination
              current={pagination.page_number}
              total={pagination.total_pages}
              onPageChange={handlePageChange}
              totalPages={totalPages}
            />
          </div>

          {/* Bulk Actions Bar */}
          {selectedBatches.length > 0 && (
            <div className="fixed-bottom bg-light border-top p-3 shadow">
              <div className="container-fluid">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <span className="fw-bold">{selectedBatches.length} batch(es) selected</span>
                  </div>
                  <div className="col-md-6 text-end">
                    <button className="btn btn-sm btn-outline-primary me-2">
                      Bulk Update
                    </button>
                    <button className="btn btn-sm btn-outline-success me-2">
                      Export Selected
                    </button>
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => setSelectedBatches([])}
                    >
                      Clear Selection
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal for Generate sample  */}
          <Modal
            show={isModalOpen}
            onHide={() => { setIsModalOpen(false); setSelectedValue(""); }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Select Batch Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="mt-3">
                <Form.Label>Choose a category:</Form.Label>
                <SelectDropdown
                  options={categoryOptions}
                  placeholder="--Choose--"
                  value={selectedValue}
                  onChange={(val) => setSelectedValue(val)}
                  disabled={generatingSample[pendingBatch?.id]}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer style={{ marginTop: '10px' }}>
              <Button
                variant="primary"
                onClick={async () => {
                  await handleGenerateSample(pendingBatch, selectedValue);
                  setIsModalOpen(false);
                  setSelectedValue("");
                }}
                disabled={!selectedValue || generatingSample[pendingBatch?.id]}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal for Send sample to client  */}
          <Modal
            show={isModalOpenClient}
            onHide={() => { setIsModalOpenClient(false); setSelectedValue(""); }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Select Batch Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="mt-3">
                <Form.Label>Choose a category:</Form.Label>
                <SelectDropdown
                  options={categoryOptions}
                  placeholder="--Choose--"
                  value={selectedValue}
                  onChange={(val) => setSelectedValue(val)}
                  disabled={sendingSample[pendingBatch?.id]}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer style={{ marginTop: '10px' }}>
              <Button
                variant="primary"
                onClick={async () => {
                  await handleSendSampleToClient(pendingBatch, selectedValue);
                  setIsModalOpenClient(false);
                  setSelectedValue("");
                }}
                disabled={!selectedValue || sendingSample[pendingBatch?.id]}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Modal for approve sample  */}
          <Modal
            show={isModalOpenForApprove}
            onHide={() => { setIsModalOpenForApprove(false); setSelectedValue(""); }}
          >
            <Modal.Header closeButton>
              <Modal.Title>Select Batch Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="mt-3">
                <Form.Label>Choose a category:</Form.Label>
                <SelectDropdown
                  options={categoryOptions}
                  placeholder="--Choose--"
                  value={selectedValue}
                  onChange={(val) => setSelectedValue(val)}
                  disabled={approvingSample[pendingBatch?.id]}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer style={{ marginTop: '10px' }}>
              <Button
                variant="primary"
                onClick={async () => {
                  await handleApproveSample(pendingBatch, selectedValue);
                  setIsModalOpenForApprove(false);
                  setSelectedValue("");
                }}
                disabled={!selectedValue || approvingSample[pendingBatch?.id]}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>

        </>
      )}
    </>
  )
}
